import LoadGroupJourney from "./LoadGroupJourney";

export default LoadGroupJourney;